import httpClient from "@/services/httpClient";
import {
  server
} from "@/services/constants";

export const getLeaveAllEvent = (com_id) => {
    return httpClient.get(server.COMPANY_EVENT + `/get/${com_id}`);
};
export const getAllYearEvent = (com_id) => {
    return httpClient.get(server.COMPANY_EVENT + `/get-year/${com_id}`);
};
export const getAllMonthEvent = (query) => {
    return httpClient.get(server.COMPANY_EVENT + `/get-month`, query);
};

export const getEventByDate = (date,com_id) => {
    return httpClient.get(server.COMPANY_EVENT + `/getbydate/${date}/${com_id}`);
};

export const createEvent = (data) => {
  return httpClient.post(server.COMPANY_EVENT, data);
};
export const importEvent = (data) => {
  return httpClient.post(server.COMPANY_EVENT +`/import`, data);
};

export const editEvent = (id,data) => {
  return httpClient.put(server.COMPANY_EVENT + `/${id}`, data);
};

export const deleteEvent = (id) => {
  return httpClient.delete(server.COMPANY_EVENT + `/${id}`);
};
  